export const ROUTER_VARIABLES = {
  org: "org",
  eventId: "eid",
  employerEventId: "employerEventId",
  universityEventId: "universityEventId",
  scheduleId: "scheduleId",
  jobId: "jobId",
  studentExtension: "studentExtension",
  interviewerExtension: "interviewerExtension",
  tempEmployerRegistrantExtension: "tempEmployerRegistrantExtension",
  employerRegistrationEventExtension: "employerRegistrationEventExtension",
  workAllocation: {
    programId: "programId",
    matterId: "matterId",
    associateId: "associateId",
    evaluationId: "evaluationId",
    groupId: "groupId",
  },
  forward: {
    eventHostOrgFriendlyName: "eventHostOrgFriendlyName",
    eventId: "eventId",
    recruitAttendeeExtension: "recruitAttendeeExtension",
  },
  pipelineTemplateId: "pipelineTemplateId",
  // E.g. distinguished from superadmin for firm profile
  firmFriendlyName: "firmFriendlyName",
  targetOrgId: "targetOrgId",
  jobExtension: "jobExtension",
  batchId: "batchId",
  importId: "importId",
} as const;
